module.exports = __webpack_public_path__ + "img/drh5_language_sc.d924c512.png";